export default "__VITE_ASSET__DZ6DEAG3__"